import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { ArrowRightIcon } from 'lucide-react';
import { CHECKOUT_URL, PRICE } from '../data/content';
interface FloatingCtaProps {
  /** Element id of the first CTA — the floating bar appears once it is scrolled past. */
  triggerId: string;
}
export function FloatingCta({
  triggerId
}: FloatingCtaProps) {
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const check = () => {
      const trigger = document.getElementById(triggerId);
      if (!trigger) return;
      setVisible(trigger.getBoundingClientRect().bottom < 0);
    };
    check();
    window.addEventListener('scroll', check, {
      passive: true
    });
    window.addEventListener('resize', check);
    return () => {
      window.removeEventListener('scroll', check);
      window.removeEventListener('resize', check);
    };
  }, [triggerId]);
  const handleClick = () => {
    if (typeof window !== 'undefined' && window.fbq) {
      window.fbq('track', 'InitiateCheckout');
    }
  };
  return <AnimatePresence data-id="element-34" data-mp="2b4jvplegm6ml">
      {visible ? <motion.div initial={{
      y: 90,
      opacity: 0
    }} animate={{
      y: 0,
      opacity: 1
    }} exit={{
      y: 90,
      opacity: 0
    }} transition={{
      duration: 0.25,
      ease: [0.23, 1, 0.32, 1]
    }} className="fixed inset-x-0 bottom-0 z-40 border-t border-navy-deep/10 bg-cream/95 px-3 pb-3 pt-3 backdrop-blur-sm sm:px-6" data-id="element-35" data-mp="2f4k7sze365qh">
          <div className="mx-auto flex max-w-2xl items-center gap-3" data-id="element-36" data-mp="1rgkjs785stfl">
            <a href={CHECKOUT_URL} onClick={handleClick} className="animate-ctaShake flex flex-1 items-center justify-center gap-2 rounded-2xl bg-kidney px-4 py-3.5 text-[14px] font-extrabold uppercase leading-tight tracking-[0.02em] text-white shadow-[0_8px_0_rgba(0,0,0,0.18)] transition-[background-color,transform] duration-150 ease-out hover:bg-kidney-dark active:translate-y-[2px] sm:text-base" data-id="element-37" data-mp="1wecbb04w6dj9">
              <span data-id="element-38" data-mp="3fbz4nn5167j2">Voglio il Percorso Renale — {PRICE}</span>
              <ArrowRightIcon className="h-4 w-4 shrink-0" aria-hidden="true" data-id="element-39" data-mp="3fdk0rh6ztyj1" />
            </a>
          </div>
          <p className="mx-auto mt-2 max-w-2xl text-center text-[11px] font-semibold uppercase tracking-[0.08em] text-navy/60" data-id="element-40" data-mp="3bcqbokhtedok">
            Download immediato • Accesso a vita • Garanzia 7 giorni
          </p>
        </motion.div> : null}
    </AnimatePresence>;
}